import axios from 'axios';
import { useSnackbar } from '../components/SnackbarContext';

export const useApiErrorHandler = () => {
  const { showSnackbar } = useSnackbar();

  return (error: unknown) => {
    if (axios.isAxiosError(error)) {
      showSnackbar(`API error: ${error.response?.data?.message}`, 'error');
    } else if (error instanceof Error) {
      showSnackbar(`General error: ${error.message}`, 'error');
    } else {
      console.error('Unknown error:', error);
      showSnackbar(`Unknown error: ${error}`, 'error');
    }
  };
};
